/**
 * Client-side canary routing: selected tenants send their traffic to an alternative backend.
 * This is routing only, never authorization.
 */
type Env = Record<string, string | undefined>
type TenantId = string | number | null | undefined

const clean = (value?: string) => (value || '').trim()

export const createTenantRouting = (readEnv: () => Env) => {
  let activeTenant: string | null = null

  const isCanaryTenant = () => {
    if (activeTenant === null) return false
    const tenants = clean(readEnv().REACT_APP_CANARY_TENANTS)
      .split(',')
      .map(clean)
      .filter(Boolean)
    return tenants.includes(activeTenant)
  }

  const resolve = (defaultKey: string, canaryKey: string) => {
    const env = readEnv()
    const canaryUrl = clean(env[canaryKey])
    return isCanaryTenant() && canaryUrl ? canaryUrl : env[defaultKey]
  }

  return {
    setActiveTenant: (id: TenantId) => {
      const value = id === null || id === undefined ? '' : clean(String(id))
      activeTenant = value || null
    },
    getApiBaseUrl: () => resolve('REACT_APP_API_URL', 'REACT_APP_CANARY_API_URL'),
    getPer1BaseUrl: () => resolve('REACT_APP_PER1_URL', 'REACT_APP_CANARY_PER1_URL'),
  }
}

// CRA inlines process.env.REACT_APP_* only on literal access, so each var is read explicitly.
const tenantRouting = createTenantRouting(() => ({
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_PER1_URL: process.env.REACT_APP_PER1_URL,
  REACT_APP_CANARY_TENANTS: process.env.REACT_APP_CANARY_TENANTS,
  REACT_APP_CANARY_API_URL: process.env.REACT_APP_CANARY_API_URL,
  REACT_APP_CANARY_PER1_URL: process.env.REACT_APP_CANARY_PER1_URL,
}))

export const { setActiveTenant, getApiBaseUrl, getPer1BaseUrl } = tenantRouting
